<template>
  <div>
    <remote-control v-if="presentation && currentState"
                    :current-state="currentState"
                    :presentation="presentation"
                    @terminate="exitModal=true"
                    standalone/>

    <yes-no-modal v-if="exitModal"
                  additional-text="This will end the session for everyone."
                  question="Are you sure you want to leave this presentation?"
                  @no="exitModal=false" @yes="terminateSession"/>
  </div>
</template>
<script>
import api from '../../services/groupsPlaceApi.js'
import RemoteControl from './RemoteControl'
import YesNoModal from "../common/YesNoModal";
import presentationControls from "../../services/presentationControls";

export default {
  name: "presentation-standalone-remote",
  components: {
    RemoteControl,
    YesNoModal
  },
  computed: {
    loggedIn() {
      return this.$store.state.loggedIn
    },
    currentUser() {
      return this.$store.state.userDetails
    },
    settings() {
      return this.$store.state.settings
    },
  },
  data() {
    return {
      presentation: null,
      currentState: {status: "", openToUser: false, attendees: []},
      exitModal: false
    }
  },
  mounted() {
    this.loadPresentation()
    let el = document.getElementById("top-header")
    if (el) el.style.display = "none"
  },
  methods: {
    loadPresentation() {
      this.$store.dispatch("setExecuting", true)
      let lastToken = localStorage.getItem("lastPresentationToken")
      let url = "/presentationViewer/start/" + this.$route.params.sessionId
      if (lastToken) url += "?lastToken=" + lastToken
      api.post(url, {password: null, name: null}).then(
        (results) => {
          this.presentation = results.data
          this.connectSocket()
        },
        (error) => {
          this.$notify.error({message: error.response.data})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    connectSocket() {
      if (!this.presentation.socketsURL) {
        this.connectionFailed = true
        this.connectionMessage = "A configuration is missing to enable communications for this service."
        return
      }
      try {
        this.socketConnection = new WebSocket("wss://" + this.presentation.socketsURL)
      } catch (e) {
        this.connectionFailed = true
        this.connectionMessage = "Could not connect to presentation services. " + e
        return
      }

      this.socketConnection.onmessage = (event) => {
        let eventData = JSON.parse(event.data)
        if (eventData.action == "getConnectionId") {
          api.post("/presentationViewer/storeRemoteSocket/" + this.$route.params.sessionId, {
            token: this.presentation.accessToken,
            connectionId: eventData.connectionId
          }).then(
            (results) => {
              this.connectionConfirmed = true
              this.currentState = results.data
            },
            (error) => {
              this.$notify.error({message: error.response.data, timeOut: 5000})
            })
        } else {
          this.handleSocketMessage(eventData)
        }
      }
      this.socketConnection.onclose = (event) => {
        this.connectionClosed = true
      }
      this.socketConnection.onopen = (event) => {
        let payload = {action: "sendmessage", innerAction: "confirmConnection", data: ""}
        this.socketConnection.send(JSON.stringify(payload))
      }
    },
    terminateSession() {
      this.exitModal = false
      presentationControls.terminateSession(this.presentation)
      this.presentation = null
      this.currentState = null
    },
    handleSocketMessage(event) {
      if (!this.currentState) return
      if (event.innerAction == "sessionTerminated") {
        this.socketConnection.close()
        this.presentation = null
        this.currentState = null
        this.terminated = true
      }
      if (event.innerAction == "setStatus") {
        this.currentState.status = event.status
      }
      if (event.innerAction == "presentationSwitched") {
        this.presentation.name = event.name
        this.currentState = event.currentState
      }
      if (event.innerAction == "openToUser") {
        this.currentState.openToUser = true
      }
      if (event.innerAction == "closeToUser") {
        this.currentState.openToUser = false
      }
      if (event.innerAction == "newPage") {
        this.currentState.currentPageId = event.currentPageId
        this.currentState.currentPageName = event.currentPageName
        this.currentState.openToUser = event.openToUser
        this.currentState.type = event.type
      }
      if (event.innerAction == "userConnected") {
        let loc = -1
        for (let i = 0; i < this.currentState.attendees.length; i++) {
          if (this.currentState.attendees[i].id == event.id) {
            loc = i
          }
        }
        if (loc == -1) {
          this.currentState.attendees.push({id: event.id, name: event.name, avatar: event.avatar})
        }
      }
      if (event.innerAction == "userDisconnected") {
        let loc = -1
        for (let i = 0; i < this.currentState.attendees.length; i++) {
          if (this.currentState.attendees[i].id == event.id) {
            loc = i
          }
        }
        if (loc >= 0) this.currentState.attendees.splice(loc, 1)
      }
      if (event.innerAction == "guestNameChange") {
        let loc = -1
        for (let i = 0; i < this.currentState.attendees.length; i++) {
          if (this.currentState.attendees[i].id == event.id) {
            this.currentState.attendees[i].name = event.name
          }
        }
      }
    }
  }
};

</script>
